import styled from "styled-components";

/* Contenedor principal (dos columnas) */
export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

/* Sidebar dinámico */
export const Sidebar = styled.div`
  width: 260px;
  background: #fff;
  border-right: 1px solid #ddd;
  padding: 20px 15px;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.08);
  overflow-y: auto;
  overflow-x: hidden;

  /* Scroll elegante */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #c7c7c7;
    border-radius: 10px;
  }
`;

/* Lista principal */
export const CalcList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

/* Item del menú */
export const CalcItem = styled.li`
  padding: 2px;
  margin-bottom: 4px;
  background: ${({ active }) => (active ? "#dbeafe" : "#f9f9f9")};
  border-left: ${({ active }) => (active ? "4px solid #2563eb" : "4px solid transparent")};
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  transition: 0.2s;

  &:hover {
    background: #e6f0ff;
  }
`;


/* Panel derecho donde cargan las vistas */
// export const MainPanel = styled.div`
//   flex: 1;
//   padding: 10px 20px;
//   display: flex;
//   flex-direction: column;
// `;
export const MainPanel = styled.div`
  flex: 1;
  padding: 20px;
  background: #f3f4f6;        /* gris suave */
  border-radius: 12px;
  margin: 0px 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
`;


/* Tarjeta visual para módulos o vistas */
export const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 20px;
`;

/* Encabezado azul suave */
export const FranjaTitle = styled.div`
  background-color: #9cc5f98a;
  color: #333;
  font-weight: bold;
  padding: 12px 20px;
  font-size: var(--app-font-size);
  border-radius: 12px 12px 0 0;
  text-align: center;
`;

/* Grid reutilizable 4 columnas */
export const GridComplement = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  gap: 12px;
  padding: 20px;
`;

/* Grid reutilizable 2 columnas */
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(220px, 1fr));
  gap: 12px;
  padding: 20px;
`;

/* Campo */
export const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

/* Etiqueta */
export const Label = styled.label`
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
`;

/* Input visual uniforme */
export const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: var(--app-font-size);
  border: 1px solid #ccc;
  border-radius: 8px;
`;

/* Select */
export const Select = styled.select`
  width: 100%;
  padding: 10px;
  font-size: var(--app-font-size);
  border: 1px solid #ccc;
  border-radius: 8px;
`;

/* Grupo de botones */
export const IconButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  padding: 0 20px;
`;

/* Resultado dinámico */
export const Result = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  font-size: var(--app-font-size);
  font-weight: bold;
  color: ${({ value }) => (value < 60 ? "#d9534f" : "#28a745")};
  margin-top: 5px;
`;


export const ViewWrapper = styled.div`
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;